import React from 'react';

export const withCondition = <Props extends object>(
  Component: React.FC<Props>,
): (shouldRender: boolean) => React.FC<Props> => {
  const HiddenComponent: React.FC<Props> = () => null;

  return (shouldRender) => shouldRender ? Component : HiddenComponent;
};
